var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHaidiAtbPathogensIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 12,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.941 1.059a1.059 1.059 0 1 1 2.118 0 1.059 1.059 0 0 1-2.118 0Zm-3.176 2.47a1.059 1.059 0 1 1 2.118 0 1.059 1.059 0 0 1-2.118 0ZM.94 6A1.059 1.059 0 1 1 3.06 6 1.059 1.059 0 0 1 .941 6Zm6 0A1.059 1.059 0 1 1 9.06 6a1.059 1.059 0 0 1-2.118 0ZM4.824 7.412a1.059 1.059 0 1 0 0 2.117 1.059 1.059 0 0 0 0-2.117ZM8 9.882A1.059 1.059 0 1 0 8 12a1.059 1.059 0 0 0 0-2.118Z",
  clipRule: "evenodd"
})));
export default SvgHaidiAtbPathogensIcon;